import { Routes } from '@angular/router';

// Proteção
import { AuthGuardService } from './services/auth-guard.service';

// Layouts
import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';
import { AdvisorLayoutComponent } from './layouts/advisor/advisor-layout.component';
import { ClientLayoutComponent } from './layouts/client/cliet-layout.component';

export const AppRoutes: Routes = [
    {
        path: '',
        redirectTo: 'pages/login',
        pathMatch: 'full',
    }, {
        path: '',
        component: AuthLayoutComponent,
        children: [{
            path: 'pages',
            loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule)
        }]
    }, {
        path: '',
        component: AdminLayoutComponent,
        canActivate: [AuthGuardService],
        children: [
            {
                path: '',
                loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
                canActivate: [AuthGuardService]
            }, {
                path: 'clientes',
                loadChildren: () => import('./clientes/clientes.module').then(m => m.ClientesModule),
                canActivate: [AuthGuardService]
            }, {
                path: 'estudos',
                loadChildren: () => import('./estudos/estudos.module').then(m => m.EstudosModule),
                canActivate: [AuthGuardService]
            }, {
                path: '',
                loadChildren: () => import('./userpage/user.module').then(m => m.UserModule),
                canActivate: [AuthGuardService]
            }, {
                path: 'admin',
                loadChildren: () => import('./admin/admin.module').then(m => m.ClientesModule),
                canActivate: [AuthGuardService]
            }, {
                path: 'components',
                loadChildren: () => import('./components/components.module').then(m => m.ComponentsModule),
                canActivate: [AuthGuardService]
            }
        ]
    }, {
        path: '',
        component: AdvisorLayoutComponent,
        canActivate: [AuthGuardService],
        children: [
            {
                path: '',
                loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
                canActivate: [AuthGuardService]
            }, {
                path: 'clientes',
                loadChildren: () => import('./clientes/clientes.module').then(m => m.ClientesModule),
                canActivate: [AuthGuardService]
            }, {
                path: 'estudos',
                loadChildren: () => import('./estudos/estudos.module').then(m => m.EstudosModule),
                canActivate: [AuthGuardService]
            }, {
                path: '',
                loadChildren: () => import('./userpage/user.module').then(m => m.UserModule),
                canActivate: [AuthGuardService]
            }
        ]
    }, {
        path: '',
        component: ClientLayoutComponent,
        canActivate: [AuthGuardService],
        children: [
            {
                path: '',
                loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
                canActivate: [AuthGuardService]
            }, {
                path: 'estudos',
                loadChildren: () => import('./estudos/estudos.module').then(m => m.EstudosModule),
                canActivate: [AuthGuardService]
            }, {
                path: '',
                loadChildren: () => import('./userpage/user.module').then(m => m.UserModule),
                canActivate: [AuthGuardService]
            }
        ]
    }
];
